import React, { useState, useEffect } from 'react';
import Embed from 'react-embed';

export const services = [
  'Twitter',
  'YouTube',
  'Vimeo',
  'Instagram',
  'FacebookVideo',
  'GoogleMaps',
  'SoundCloud',
  'Twitch',
];

const EmbedMedia = ({ url }) => <NoSSR><Embed url={url} /></NoSSR>;

// The dependency react-embed will (by default) drag in Suspense, which is incompatible with SSR. We wrap it with NoSSR to prevent the breaking error that causes.
const NoSSR = ({ children }) => {
  const [render, setRender] = useState(false);
  useEffect(() => setRender(true), []);
  if (render) {
    return <>{children}</>;
  }
  return null;
};

export default EmbedMedia;
